// extracted by mini-css-extract-plugin
export default {"mCard":"Ix-z","image":"Jx-z","imageNoBackground":"Kx-z","fullWidth":"Lx-z"};